import { observer } from "mobx-react-lite";
import React from "react";

import FormField from "../form-field/FormField";

interface Description {
  description: string;
  labelKey?: string;
}

export default observer(function DisplayDescription(props: Description) {
  return (
    <FormField
      id="description"
      readOnly
      labelKey={props.labelKey || "general.description"}
      fieldValue={props.description}
    />
  );
});
